<!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8">
    <title>Daylily</title>
    <base href="/">
    <meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no">
    <link rel="icon" type="image/x-icon" href="favicon.ico">
    <link href="https://cdn.syncfusion.com/ej2/material.css" rel="stylesheet" />
    <link rel="stylesheet" href="/assets/css/main.css" />
  </head>
  <body>
    <div class="feed">
  <router-outlet></router-outlet>
</div>
</body>
</html>
